import { createTermTagManager } from '../../utils/createTermTagManager';

export const offerIdTagManager = createTermTagManager({
  jsonQueryKey: 'id',
  template: 'Объявление №%s',
  id: 'offerId',
});
